export default "__VITE_ASSET__CGvc4IPp__"